import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { User } from './model/user.model';
import { ErrorCode } from '../../models/error-code.model';
import { UserCredentials } from './model/user-credentials.model';
import { UserSignUp } from '../../models/authentication/user-sign-up.model';

export const AuthenticationApiActions = createActionGroup({
    source: 'API/Authentication',
    events: {
        'sign in': props<{ credentials: UserCredentials }>(),
        'reset password': props<{ email: string }>(),
        'sign out': emptyProps(),
        'sign up': props<{ userData: UserSignUp }>()
    }
});

export const AuthenticationActions = createActionGroup({
    source: 'Authentication',
    events: {
        'sign in success': props<{ user: User }>(),
        'sign in failure': props<{ error: ErrorCode }>(),
        'sign up success': emptyProps(),
        'sign up failure': props<{ error: ErrorCode }>(),
        'reset password success': emptyProps(),
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        'reset password failure': props<{ error: any }>(),
        'recover password': props<{ token: string; password: string; passwordConfirm: string }>(),
        'recover password success': emptyProps(),
        'recover password failure': props<{ error: ErrorCode }>(),
        'sign out success': emptyProps(),
        'set user': props<{ user: User }>(),
        'save user': props<{ user: User }>(),
        'clear storage': emptyProps(),
        'refresh push token': props<{ token: string }>(),
        'clear errors': emptyProps(),
        'authentication failed': emptyProps()
    }
});
